window.c.FollowUserApi = function () {
  function FollowUserApi() {}
  FollowUserApi.prototype.blockUser = function (user_id) {
    return this._postBlock(user_id, 'POST');
  };
  FollowUserApi.prototype.unblockUser = function (user_id) {
    return this._postBlock(user_id, 'DELETE');
  };
  FollowUserApi.prototype._postBlock = function (user_id, method) {
    return $.ajax({
      url: $r.api_v0_user_blocks_path({
        user_id: user_id,
        subdomain_param: 'api'
      }),
      type: 'POST',
      data: {
        _method: method
      }
    });
  };
  return FollowUserApi;
}();
window.Follow = new c.FollowUserApi();